import Faq from "./Faq.container";

export default Faq;
